module.exports = __webpack_public_path__ + "img/C04TechMangonelGalleyS_ua.41cddee0.webp";